<script setup lang="ts">
    import DataTableActions from '@/components/datatable/DataTableActions.vue';
    import { Payroll, SharedData } from '@/types';
    import { usePermissions } from '@/composables/usePermissions';
    import Delete from '@/components/Delete.vue';
    import Permission from '@/enums/Permission';
    import QueryKey from '@/enums/QueryKey';
    import { Link } from '@inertiajs/vue3';
    import { usePage, router } from '@inertiajs/vue3';
    import { computed } from 'vue';
    import EditButton from '@/components/EditButton.vue';
    import ContinueButton from '@/components/ContinueButton.vue';

    const page = usePage<SharedData>();
    const selectedCompanyId = computed(() => page.props.auth.user.selected_company_id);

    interface Props {
        payroll: Payroll;
    }

    const props = defineProps<Props>();

    const { hasPermission } = usePermissions();

    const editPayroll = () => {
        router.visit(route('v2.salary.payrolls.show', { payrollId: props.payroll.id }));
    };
</script>

<template>
    <DataTableActions
        v-if="payroll.approved_by || !hasPermission(Permission.SALARY_PAYROLLS_UPDATE)"
        :data="payroll"
    >
        <ContinueButton
            v-if="hasPermission(Permission.SALARY_PAYROLLS_VIEW)"
            @click="editPayroll"
        >
            {{ $t('forms.open') }}
        </ContinueButton>
    </DataTableActions>
    <DataTableActions
        v-else-if="!payroll.approved_by"
        :data="payroll"
    >
        <EditButton
            v-if="hasPermission(Permission.SALARY_PAYROLLS_UPDATE)"
            @click="editPayroll"
        >
            {{ $t('forms.edit') }}
        </EditButton>
        <Delete
            v-if="hasPermission(Permission.SALARY_PAYROLLS_DELETE)"
            :route="route('v2.salary.payrolls.destroy')"
            :query-key="[QueryKey.PAYROLLS, selectedCompanyId]"
            header="salary.js.delete_title"
            description="salary.js.delete_content"
            success-message="payrolls.deleted.success"
            method="post"
            :request-data="{ id: payroll.id }"
        />
    </DataTableActions>
</template>
